// Copyright 2019, White Label Communications, LLC, All rights reserved.
import {
  FETCH_INTEGRATION_LIST,
} from 'actions/IntegrationSettingActions';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_INTEGRATION_LIST:
      return {
        ...state,
        list: action.data,
      };
    default:
      return state;
  }
}
